export const isTouchDevice = (): boolean => {
  try {
    const prefixes = " -webkit- -moz- -o- -ms- ".split(" ");

    const mq = (query: string): boolean => {
      return window.matchMedia(query).matches;
    };

    if (
      "ontouchstart" in window ||
      // @ts-ignore
      (typeof window.DocumentTouch !== "undefined" &&
        // @ts-ignore
        document instanceof window.DocumentTouch)
    ) {
      return true;
    }

    return mq(["(", prefixes.join("touch-enabled),("), "heartz", ")"].join(""));
  } catch (e) {
    console.error("(Touch detect failed)", e);
    return false;
  }
};
